module.exports = __webpack_public_path__ + "img/photo-20.642aed85.jpg";